import {makeStyles} from 'tss-react/mui'

export const useTableStyles = makeStyles()((theme) => ({
  tableCellRightShadow: {
    position: 'relative',
    '&::after': {
      content: '""',
      height: '100%',
      position: 'absolute',
      top: 0,
      width: '10px',
      boxShadow: `${theme.palette.grey[300]} 10px 0px 6px -6px inset`,
      right: '-10px'
    }
  },
  tableCellLeftShadow: {
    position: 'relative',
    '&::before': {
      content: '""',
      height: '100%',
      position: 'absolute',
      top: 0,
      width: '10px',
      boxShadow: 'rgb(0 0 0 / 11%) -10px 0px 6px -6px inset',
      left: '-10px'
    }
  },
  stickyFirstColumn: {
    position: 'sticky',
    left: 0,
    background: 'white',
    zIndex: 100
  },
  stickyFirstColumnFirstRow: {
    position: 'sticky',
    left: 0,
    background: theme.palette.grey[100],
    zIndex: 200
  },

  stickyFirstColumnStickyFirstRow: {
    position: 'sticky',
    left: 0,
    background: theme.palette.grey[100],
    zIndex: 200,
    '&::after': {
      content: '""',
      height: '100%',
      position: 'absolute',
      top: 0,
      width: '10px',
      boxShadow: `${theme.palette.grey[300]} 10px 0px 6px -6px inset`,
      right: '-10px',
      display: 'none'
    },
    '&.with-shadow::after': {
      display: 'block'
    }
  },

  stickyLastColumn: {
    position: 'sticky',
    right: 0,
    background: 'white',
    zIndex: 100
  },
  stickyLastColumnFirstRow: {
    position: 'sticky',
    right: 0,
    background: theme.palette.grey[100],
    zIndex: 100
  }
}))
